
import React from 'react'
import  '../../assets/css/CustomStyle.css'


export default function OrangeBtn(props) {
    const { className ,value} = props; 
  
    return (
    <div >
        <button  aria-label='GrayBtn' className={`${className} text-[1.125rem] group primray-bg hover:bg-[#ffa166] duration-300 transition-all 1650:py-[12px] py-[10px] px-[22px] 1650:px-[24px] rounded-[10px] flex items-center justify-start 1350:gap-[10px] gap-[8px]`}>
            <p className=' font-medium text-white '>{value}</p>
            {props.svg &&
                <div>
                    <img loading="lazy" className='group-hover:translate-x-1 transition-all duration-300 1350:w-auto 768:w-[20px] w-[18px]' src={props.svg} alt="arrow" />
                </div>
                // <props.svg />
            }
        </button>        
    </div>
    )
}
